import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ServiceChecklistEditor.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { ServiceChecklist_Types, MainCatalogs_Classes, MainCatalogTypes, YesNo_Values } from "../../_loadingHelpers/MainCatalogTypes";
import EntityStore from '../../../moreCore/Tools/EntityStore';
import lang from 'dojo/_base/lang';

import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import ExpandableSection from '../../../moreCore/UI/Container/ExpandableSection';
import { ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { SelectEntityDialogTypes } from "../../../moreCore/_loadingHelpers/SelectEntityDialog";
import { VAM2types, VAMclassNames } from "../../_loadingHelpers/VAMv2Types";

class ServiceChecklistEditor extends compose(MainCatalogsEditorBaseV2, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    tableContainer: HTMLElement;
    sectionTypeDefault: HTMLDivElement;
    sectionTypeSettings: HTMLDivElement;

    input_Type: MdsLax<InstanceType<typeof SelectBox>>;
    input_yes_no: MdsLax<InstanceType<typeof SelectBox>>;

    private inputRegistry: Record<string, { widget: MdsLax<InstanceType<typeof CheckBox>>, targetValue: any, node: HTMLElement, tableRow: StaticTable.StaticTableRow<MainCatalogTypes.HtServiceChecklistCategory> }> = {};
    

    htServiceChecklistCategoryExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    htServiceChecklistCategoryStore: MdsLax<InstanceType<typeof EntityStore<MainCatalogTypes.HtServiceChecklistCategory>>>;
    htServiceChecklistCategoryTable: MdsLax<InstanceType<typeof StaticTable>>;

    private sedFilterAttributes: any = {

    };

    tableRowLayout: StaticTable.RowConfig = {
        attributes: ["ref_service_checklist_category.description", "is_main_service_category"],
        colNamesInternal: ["ref_service_checklist_category.description", "is_main_service_category"],
        headings: [(this as any).translate("General_Label_Description"), (this as any).translate("General_Label_MainServiceCategoryChecklist")],
        colspans: [3, 1],
    }

    tableLayout: StaticTable.Layout = {
        label: "htServiceChecklistCategoryTable",
        name: "htServiceChecklistCategoryTable",
        rows: [(this as any).tableRowLayout],
    }

    isValid(): boolean {
        //Need to implement
        return true;
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.ServiceChecklist;
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        this._setInputTypeVisibility();

        let htServiceChecklistCategory = this.getAttributeValue("EL_ht_service_checklist_category_service_checklist");
        this.htServiceChecklistCategoryStore.setup(htServiceChecklistCategory);
        this.applyCheckboxValues();
        
    }

    table_Formatter(cell: StaticTable.StaticTableCell<MainCatalogTypes.HtServiceChecklistCategory>) {

        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        //let index = cell.tableRow.lineIndex;
        let value = cell.value;
        let index = cell.tableRow.rowGroup.rowIndex;
        //cell.value = null;

        switch (colName) {
            case "is_main_service_category":
                let input = this.inputRegistry[entity.ID];
                if (input) {
                    input.node = node;
                    input.tableRow = cell.tableRow;

                    this.UiModder.domConstruct.empty(node);
                    input.widget.placeAt(node);
                }
                
                return true;
            default:
                return false;
        }
    }

    protected _onTableCreated(table: MdsLax<InstanceType<typeof StaticTable>>) {
        super._onTableCreated.apply(this, arguments as any);

    }

    protected _beforeTableDrawn(table: MdsLax<InstanceType<typeof StaticTable>>) {
        super._beforeTableDrawn.apply(this, arguments as any);

        //this.tableIsReady = false;
        this.inputRegistry = {};
    }

    protected _onTableDrawn(table: MdsLax<InstanceType<typeof StaticTable>>) {
        super._onTableDrawn.apply(this, arguments as any);
        //this.tableIsReady = true;

        this.applyCheckboxValues();
    }

    private applyCheckboxValues() {

        //var htServiceChecklistCategory = this.getAttributeValue("EL_ht_service_checklist_category_service_checklist");
        var htServiceChecklistCategory: Array<MainCatalogTypes.HtServiceChecklistCategory> = this.htServiceChecklistCategoryStore.getCurrentCompleteList();

        htServiceChecklistCategory.sort((a, b) => {
            return a.ref_service_checklist_category.order - b.ref_service_checklist_category.order;
        })

        this.inputRegistry = {};
        for (let entry of htServiceChecklistCategory) {
            let checkBox = new CheckBox();
            checkBox.on("change", lang.hitch(this, this._onChange_CheckBoxValue, entry.ID));
            checkBox.setValue(entry.is_main_service_category);

            this.inputRegistry[entry.ID] = {
                node: null,
                tableRow: null,
                targetValue: entry.is_main_service_category,
                widget: checkBox
            } 
        }

        //this.htServiceChecklistCategoryStore.setup(htServiceChecklistCategory);
        this.htServiceChecklistCategoryTable.setupFromStore(this.htServiceChecklistCategoryStore);

        this.htServiceChecklistCategoryExpander.setMarking(htServiceChecklistCategory.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    private _onChange_CheckBoxValue(key_changed: string, value): void {
        if (value == false) { return }

        let values = Object.keys(this.inputRegistry);
        for (let key of values) {
            let checkBox = this.inputRegistry[key].widget;
            //let entity: MainCatalogTypes.HtServiceChecklistCategory = this.inputRegistry[key].targetValue;
            let entity = lang.clone(this.htServiceChecklistCategoryStore.getEntityById(key));

            if (key !== key_changed) {
                checkBox.setChecked(false);
                checkBox.setIsReadOnly(false);
                entity.is_main_service_category = false;
            }
            else if (key === key_changed) {
                checkBox.setIsReadOnly(true);
                entity.is_main_service_category = true;
            }

            //this.htServiceChecklistCategoryStore.changeEntry(entity, true);
            if (this.htServiceChecklistCategoryStore) this.htServiceChecklistCategoryStore.changeEntry(entity, true);
        }
    }

    private _setupTable(): void {
        this.htServiceChecklistCategoryTable = new StaticTable();
        this.htServiceChecklistCategoryTable.addLayout(this.tableLayout);
        this.htServiceChecklistCategoryTable.setupFromStore(this.htServiceChecklistCategoryStore);
        this.htServiceChecklistCategoryTable.setFormatter(lang.hitch(this, this.table_Formatter));
        //this.htServiceChecklistCategoryTable.setRowClick(lang.hitch(this, this._onClickTableRow));
        //this.htServiceChecklistCategoryTable.addDefaultRowActionButton("select", lang.hitch(this, this._onSelectEditTableRowButton));
        this.htServiceChecklistCategoryTable.addDefaultRowActionButton("delete");
        this.htServiceChecklistCategoryTable.setCyAttribute("ServiceChecklistCategoryTable");

        this.htServiceChecklistCategoryTable.placeAt(this.htServiceChecklistCategoryExpander);
    }

    private _onSelectEditTableRowButton(evt): void {

    }

    private _onClickAdd(evt): void {
        //console.log("click add");
        this.loadSelectEntityDialog(evt,
            "selectServiceChecklistCategory",
            lang.hitch(this, this._onCallback_Dlg),
            null,
            this.sedFilterAttributes
        );
    }

    private _onCallback_Dlg(mode: string, data, items: Array<SelectEntityDialogTypes.Item<VAM2types.Entity_description>>) {
        if (!items || !items.length) return;
        if (mode == "selectServiceChecklistCategory") {
            for (let item of items) {

                let entity: Partial<VAM2types.Entity_description> = item.entry?.data;

                if (!entity) {
                    entity = {
                        ID: item.entry.value, description: item.entry.label
                    };
                }
                else {

                }

                //console.log(enttiy);
                this.addNewEntry(entity as any);
            }
        }
    }

    private addNewEntry(value: MainCatalogTypes.ServiceChecklistCategory) {
        let fakeHtServiceChecklistCategory: Partial<MainCatalogTypes.HtServiceChecklistCategory> = {
            ref_service_checklist_category: value,
            is_main_service_category: this.htServiceChecklistCategoryStore.getCurrentCompleteList().length ? false : true
        }


        if (this.htServiceChecklistCategoryStore.isEntityExisting(fakeHtServiceChecklistCategory as any, "ref_service_checklist_category.ID", true)) {
            this.showToast({
                title: this.translate(`ServiceChecklistCategory_Toast_ExistInList`),
                message: `**${value.$Displayname}**  ${this.translate(`ServiceChecklistCategory_Toast_ExistInList_details`)}`,
                messageIcon: "fas fa-info-circle",
                iconClass: "fas fa-info-circle"
            });
        }
        else {
            this.htServiceChecklistCategoryStore.addEntry(fakeHtServiceChecklistCategory as any, "new");

            this.applyCheckboxValues();
        }
    }

    private _onChangeStore(): void {
        var htServiceChecklistCategoryDiffData = this.htServiceChecklistCategoryStore.getDiffData();
        this.setAttributeValue("htServiceChecklistCategoryDiffData", htServiceChecklistCategoryDiffData);

        this.htServiceChecklistCategoryExpander.setMarking(this.htServiceChecklistCategoryStore.getCurrentCompleteList().length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }


    private _setInputTypeVisibility(): void {
        var serviceType = this.input_Type.getValue();

        console.log(serviceType);

        switch (serviceType) {
            case 2:
                this.UiModder.domClass.toggle(this.sectionTypeSettings, "w3-hide w3-disabled", false);
                break;
            case 1:
            case 3:
            case 4:
                this.UiModder.domClass.toggle(this.sectionTypeSettings, "w3-hide w3-disabled", true);
                break;
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        //
        for (let scType in ServiceChecklist_Types) {

            let value: any = ServiceChecklist_Types[scType];

            if (!isNaN(value)) {
                this.input_Type.addOption(
                    value,
                    this.translations["serviceChecklist_type_" + value.toString()],
                    true);
            }
        }

        this.input_Type.on("change", lang.hitch(this, this._setInputTypeVisibility));
        this.input_Type.constructOptions();
        //
        // ja/nein/?
        for (let ynValue in YesNo_Values) {
            let value: any = YesNo_Values[ynValue];
     
            this.input_yes_no.addOption(
                value,
                this.translations["serviceChecklist_input_" + ynValue],
                true);
           
        }

        this.input_yes_no.constructOptions();
        //


        this.htServiceChecklistCategoryStore = new EntityStore();
        this.htServiceChecklistCategoryStore.on("change", lang.hitch(this, this._onChangeStore));
        this._setupTable();


        this.SEDconfigCallfunction = "Webtool_API_MainCatalogsEditor__SED_GetConfig";

        
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ServiceChecklistEditor);